import React from "react";
import { Button } from "@/components/ui/button";

export default function ErpPagination({ page = 1, totalPages = 1, totalItems = 0, pageSize = 10, onPageChange }) {
  const pages = Math.max(1, totalPages);
  const current = Math.min(Math.max(1, page), pages);
  const start = totalItems ? (current - 1) * pageSize + 1 : 0;
  const end = Math.min(current * pageSize, totalItems);

  return (
    <div className="flex flex-col gap-3 border-t pt-3 sm:flex-row sm:items-center sm:justify-between">
      <p className="text-xs text-slate-500" aria-live="polite">
        Menampilkan {start}–{end} dari {totalItems} data
      </p>
      <div className="flex items-center gap-2">
        <Button type="button" variant="outline" size="sm" disabled={current <= 1} onClick={() => onPageChange?.(current - 1)}>
          Sebelumnya
        </Button>
        <span className="min-w-20 text-center text-sm" aria-live="polite">
          Halaman {current} / {pages}
        </span>
        <Button type="button" variant="outline" size="sm" disabled={current >= pages} onClick={() => onPageChange?.(current + 1)}>
          Berikutnya
        </Button>
      </div>
    </div>
  );
}
